module.exports = __webpack_public_path__ + "img/article_icon.83954944.svg";